import { HCF_TESTIMONIALS, youtubeEmbed } from './testimonials';
// Brand assets - HCF Property (ex Green Paradise / HCF Group)
// ★ 2026-08-12 (Fase 44) — Rebrand: HCF Property come brand di riferimento.
//   I nomi dei singoli resort restano "Green Paradise Lombok/Spille/Chumphon" per continuità storica,
//   ma tutto il chrome (header, gate, footer, community) usa "HCF Property".
const drivePreview = (id) => `https://drive.google.com/file/d/${id}/preview`;

// ★ Fase 86 (2026-10-20) — TUTTE le immagini brand/funnel sono servite in
//   locale da /public/funnels (WebP ottimizzato). Niente più link esterni
//   (customer-assets / framer / Google Drive thumbnail) che possono essere
//   bloccati da ad-blocker o reti aziendali.
// Logo HCF Property ufficiale (caricato dall'utente 2026-08-12)
const HCF_PROPERTY_LOGO = '/funnels/hcf-property-logo.png';

export const BRAND = {
  // Brand principale (nuovo)
  name: 'HCF Property',
  logo: HCF_PROPERTY_LOGO,
  logoSmall: HCF_PROPERTY_LOGO,
  tagline: 'Community internazionale Real Estate · Alberghi & appartamenti in gestione',
  // Alias retrocompatibili — puntano al nuovo logo
  greenParadiseLogo: HCF_PROPERTY_LOGO,
  greenParadiseLogoSmall: HCF_PROPERTY_LOGO,
  luxHarmonyLogo: '/funnels/brand/lux-harmony-logo.png',
  hcfGroupLogo: HCF_PROPERTY_LOGO,
  heroLombok: '/funnels/brand/hero-lombok.webp',
  heroSpille: '/funnels/brand/hero-spille.webp',
  // Il thumbnail Drive di Chumphon non è più servito da Google: usiamo il
  // render hero Lux Harmony (stesso asset tailandese) in locale.
  heroChumphon: '/funnels/thailand/lux-harmony/lh-hero-sunset.webp',
  heroSecondary: '/funnels/brand/hero-secondary.webp',
  galleryLombok: [
    '/funnels/brand/gallery-lombok/gl-01.webp',
    '/funnels/brand/gallery-lombok/gl-02.webp',
    '/funnels/brand/gallery-lombok/gl-03.webp',
    '/funnels/brand/gallery-lombok/gl-04.webp',
    '/funnels/brand/gallery-lombok/gl-05.webp',
    '/funnels/brand/gallery-lombok/gl-06.webp',
  ],
};

// Real social links provided by user
export const SOCIALS = {
  // Instagram
  ig_estate: 'https://www.instagram.com/hcf_estate/',
  ig_property: 'https://www.instagram.com/hcf_property/',
  ig_greenparadise: 'https://www.instagram.com/hcf_greenparadise/',
  // YouTube
  yt_group: 'https://youtube.com/@hcfgroup',
  yt_property: 'https://youtube.com/@hcf_property',
  yt_estate: 'https://youtube.com/@hcfestate',
  // LinkedIn
  linkedin: 'https://www.linkedin.com/company/hcfgroup/',
  // Other
  hcf_main: 'https://www.housecashflows.com/',
  green_paradise_page: 'https://www.housecashflows.com/green-paradise',
  lux_harmony_page: 'https://www.housecashflows.com/lux-harmony',
  // Email
  email: 'greenparadise@housecashflows.com',
};

// VSL videos (YouTube IDs + Calendly for live-agent variants).
// ★ 2026-08-13 (Fase 51 · Compliance CONSOB) — Variante "equity" mantenuta
//   nel routing per non rompere link storici, ma reindirizza al video Real Estate.
// ★ 2026-08-14 (Fase 52 · Video-gate FIX) — Il vecchio ID `j9_HhKF2xgA` non era
//   più disponibile su YouTube ("Video unavailable") e fu sostituito con
//   `j9_HhKF2xgA` (Real Estate).
// ★ 2026-10-03 (Fase 37 · Fix VSL) — `j9_HhKF2xgA` ha l'incorporamento
//   DISABILITATO su YouTube (embed = "Video unavailable"). Il video ufficiale
//   `j9_HhKF2xgA` ("Non è solo immobiliare, è un ecosistema" · HCF Group) è
//   tornato disponibile: ripristinato ovunque su indicazione dell'utente.
export const VSL_VIDEOS = {
  initial: { youtubeId: 'j9_HhKF2xgA', title: 'HCF Property — La presentazione ufficiale' },
  equity: { youtubeId: 'j9_HhKF2xgA', title: 'Verification Pass · Real Estate' },
  'real-estate': { youtubeId: 'j9_HhKF2xgA', title: 'Verification Pass · Real Estate' },
};

// Showcase videos (Drive embeds + YouTube)
// drivePreview() returns a /preview URL embeddable via <iframe>
export const SHOWCASE_VIDEOS = [
  { type: 'drive', id: '17mSX0iSUDtzBKYKjwRboTE4dmN56Bien', title: 'Riconoscimenti & milestone', url: drivePreview('17mSX0iSUDtzBKYKjwRboTE4dmN56Bien') },
  { type: 'drive', id: '1gwn4PxGqhJ45hMjmy9zREQkdaDZNCKGe', title: 'I nostri progetti in azione', url: drivePreview('1gwn4PxGqhJ45hMjmy9zREQkdaDZNCKGe') },
  { type: 'drive', id: '1abcBgPDUnow5DElWU-4Zu2kVidpxdBGW', title: 'Behind the scenes', url: drivePreview('1abcBgPDUnow5DElWU-4Zu2kVidpxdBGW') },
  { type: 'drive', id: '1a42Mbh0rzB9uR2Ec-X2OF6DeP1cTowBS', title: 'Vision tour', url: drivePreview('1a42Mbh0rzB9uR2Ec-X2OF6DeP1cTowBS') },
];

// ★ 2026-10-22 — Albania: aggiunti i due video dei Verification Pass reali (ottobre 2026 · maggio 2026).
export const VERIFICATION_PASS_VIDEOS = [
  { type: 'youtube', country: 'Albania', flag: '🇦🇱', id: 'gBdZ_-Y2s6w', url: 'https://www.youtube.com/embed/gBdZ_-Y2s6w?rel=0&modestbranding=1&autoplay=1&mute=0', title: 'Verification Pass · Albania (9–11 ottobre 2026)' },
  { type: 'youtube', country: 'Albania-maggio', flag: '🇦🇱', id: 'nuB7YvUuwMU', url: 'https://www.youtube.com/embed/nuB7YvUuwMU?rel=0&modestbranding=1&autoplay=1&mute=0', title: 'Verification Pass · Albania (15–17 maggio 2026)' },
  { type: 'youtube', country: 'Albania-programma', flag: '🇦🇱', id: 'DEEz5eXicGU', url: 'https://www.youtube.com/embed/DEEz5eXicGU?rel=0&modestbranding=1&autoplay=1&mute=0', title: 'Verification Pass · Albania — il programma' },
  { type: 'youtube', country: 'Indonesia', flag: '🇮🇩', id: 'V0Z643ZA4Pg', url: 'https://www.youtube.com/embed/V0Z643ZA4Pg?rel=0&modestbranding=1&autoplay=1&mute=0', title: 'Verification Pass · Indonesia (Lombok)' },
];

// "Dicono di noi" — testimonial videos on the landing page
// ★ 2026-10-19 — fonte unica lib/testimonials.js (14 video, stessi dei funnel).
export const TESTIMONIAL_VIDEOS = HCF_TESTIMONIALS.map((v) => ({
  type: 'youtube',
  id: v.id,
  url: youtubeEmbed(v.id, { autoplay: true }),
  title: v.it,
  name: v.name,
}));

// Resort-specific video (shown on each ResortDetailPage below the calculator)
// ★ 2026-08-13 (Fase 49) — Su richiesta utente TUTTI i resort usano lo stesso
//   video hero "in 20 minuti" (video ufficiale del gruppo, ID: j9_HhKF2xgA).
//   Il titolo H2 "Guarda {nome} in 20 minuti" resta dinamico (già gestito
//   in ResortDetailPage.jsx).
export const RESORT_VIDEOS = {
  lombok:   { youtubeId: 'j9_HhKF2xgA', title: 'Green Paradise Lombok · Video 20 minuti' },
  spille:   { youtubeId: 'j9_HhKF2xgA', title: 'Green Paradise Spille · Video 20 minuti' },
  chumphon: { youtubeId: 'j9_HhKF2xgA', title: 'Green Paradise Chumphon · Video 20 minuti' },
  // ★ Fase 43 (2026-10) — La Mar Residence ELIMINATA definitivamente (richiesta utente).
  // ★ 2026-08-12 (Fase 43) — Narea.
  'narea': { youtubeId: 'j9_HhKF2xgA', title: 'Narea · Albania' },
};

// ★ 2026-08-11 (Fase 37) — Video default per pagine resort che non hanno un video proprio.
// Usato come hero header in tutte le ResortDetailPage.
export const DEFAULT_RESORT_HERO_VIDEO = { youtubeId: 'j9_HhKF2xgA', title: 'HCF Property · Presentazione' };

// ★ Fase 43 (2026-10) — La Mar Residence eliminata definitivamente.
export const RESORT_SECONDARY_VIDEOS = {
  'narea': { youtubeId: 'DEEz5eXicGU', title: 'Verification Pass · Narea', label: 'Approfondimento · Verification Pass' },
};

// ★ 2026-08-13 (Fase 50) — Griglia 4 video "hero secondari" specifica per Lombok.
//   Mostrata subito sotto la hero image + stats strip (prima della tabella).
export const LOMBOK_HERO_VIDEOS = [
  { youtubeId: 'jKWYCgoPbAM', title: 'Green Paradise Lombok · Bumbang Bay overview' },
  { youtubeId: 'gMr0CG1w92k', title: 'Green Paradise Lombok · Vista drone' },
  { youtubeId: 'URsPnkpoq2s', title: 'Green Paradise Lombok · Team & cantiere' },
  { youtubeId: 'V0Z643ZA4Pg', title: 'Verification Pass · Indonesia (Lombok)' },
];

// ★ 2026-08-11 (Fase 37 update) — Video "Verification Pass" secondario.
//   Mostrato tra la sezione Documenti e le FAQ (approfondimento aziendale).

export const RECOGNITIONS_FOLDER = 'https://drive.google.com/drive/folders/1AH7WZmuYC8DlOxSZuHPLv0y5qo9xy-9e?usp=drive_link';

// Physical locations: HQs, offices and active construction sites.
// Used in the public footer + ResortDetailPage + AI system prompt.
export const LOCATIONS = {
  hq_bulgaria: {
    flag: '🇧🇬',
    label: 'Sede legale HCF Property',
    city: 'Sofia, Bulgaria',
    address: 'Stolichna 1797',
    type: 'hq',
  },
  office_albania: {
    flag: '🇦🇱',
    label: 'Ufficio Albania',
    city: 'Albania',
    address: 'HCF Property Sh.p.k.',
    maps_url: 'https://maps.app.goo.gl/9wFymt6mYNjpCtN96',
    type: 'office',
  },
  site_lombok: {
    flag: '🇮🇩',
    label: 'Cantiere Lombok',
    city: 'Bumbang Bay, Indonesia',
    address: 'Green Paradise Lombok',
    maps_url: 'https://maps.app.goo.gl/9dvxmEF6bxHNLmk6A?g_st=iw',
    type: 'site',
  },
};
